"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.stats.total': 'Total de Onboardings',
    'onboarding.stats.in_progress': 'En Progreso',
    'onboarding.stats.completed': 'Completados',
    'onboarding.stats.avatars_created': 'Avatares Creados',
};
